module.exports = __webpack_public_path__ + "img/9788964373774.a0c9654d.jpg";